import { css } from '@emotion/css';

export const collapseIcon = css`
	transition-duration: 500ms;
`;

export const collapseIconRotate = css`
	transform: rotate(-90deg);
	transition-duration: 500ms;
`;
